import styled from "styled-components"
import { Colors } from 'styles/app-styles'

export const ComparisonDetailView_s = styled.div`
  display: flex;
  flex-direction: row; //change to column to stack details
  font-family: 'Roboto', sans-serif;
  margin: 6px 10px 0px 10px;

  & > div {
    width: 100%;
  }

  & > div:first-child {
    min-width: 822.5px;
  }

  summary {
    background: ${Colors.inputFocus};
    flex: 0 0 100%;
    color: ${Colors.darkDenim};
    cursor: pointer;
    outline:none;
    padding: 10px;
    text-overflow: ellipsis;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    margin-right: 14px;
  }

  .small-input {
    width: 82px;
  }

  .selected-folder {
    display: flex;
    flex-direction: row;
    width: 276px;
    cursor: pointer !important;
    text-align: left;
    .path {
      display: inline-block;
      position: relative;
      top: 5px;
      width: 236px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .icon {
      display: inline-block;
      position: relative;
      top: 2px;
      padding-left: 6px;
      height: 18px;
    }
    svg {
      height: 20px;
      .r-svg { fill: ${Colors.blackPearl}; }
    }
  }

  .search {
    background: ${Colors.inputFocus};
    width: 468px;
  }
`

export const Details_s = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 16px 10px 16px;
`
